import _extends from "@babel/runtime/helpers/extends";
import React from 'react';

// Components
import colors from '@tekion/tekion-styles-next/scss/variables.scss';
import Icon, { SIZES } from '../../../../atoms/FontIcon';
import FilterDialog from '../../filterDialog';
import Badge from '../../../../atoms/BadgeWrapper/BadgeWrapper';

// constants
import { getSelectedFilterCount as getAppliedFilterCount } from './filterTrigger.helper';

// Styles
import s from './filterTrigger.module.scss';
var BADGE_STYLE = {
  backgroundColor: colors.denim,
  top: '20%',
  right: 5
};
var FilterTrigger = function FilterTrigger(props) {
  var selectedFilters = props.selectedFilters,
    filterTypes = props.filterTypes,
    _props$getSelectedFil = props.getSelectedFilterCount,
    getSelectedFilterCount = _props$getSelectedFil === void 0 ? getAppliedFilterCount : _props$getSelectedFil;
  var appliedFilterCount = getSelectedFilterCount(selectedFilters);
  return /*#__PURE__*/React.createElement(FilterDialog, _extends({}, props, {
    filterTypes: filterTypes
  }), /*#__PURE__*/React.createElement(Badge, {
    badgeContent: appliedFilterCount,
    style: BADGE_STYLE
  }, /*#__PURE__*/React.createElement(Icon, {
    size: SIZES.M,
    className: "".concat(s.icon, " cursor-pointer")
  }, "icon-filter")));
};
FilterTrigger.propTypes = FilterDialog.propTypes;
FilterTrigger.defaultProps = FilterDialog.defaultProps;
export default FilterTrigger;